





















































































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { StudentInfo } from "../../_models/studentInfo";
import { bus } from "../../main";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import { dispatchComuniList } from "../../_store/data.module";
import { ComuniInfo } from "../../_models/comuniInfo";

@Component
export default class EditStudentInfoStepper extends Vue {
  @Prop() info!: StudentInfo;
  private e1: number;
  private estero: string;
  private valid: boolean;
  private userType: string;
  private nomeUtente: string;
  private cognomeUtente: string;
  private indirizzoUtente: string;
  private telefono1Utente: string;
  private telefono2Utente: string;
  private cod: string;
  private dataNascita: string;
  private luogoNascita: string;
  private emailUtente: string;
  private pecUtente: string;
  private comuneUtente: string;
  private provinciaUtente: string;
  private entità: string;
  private idCap: number;
  private cap: string;

  private statoNascita: string;

  private nomeRules: [boolean | string];
  private cognomeRules: [boolean | string];
  private codRules: [boolean | string];
  private emailRules: [boolean | string];
  private pecRules: [boolean | string];
  private comuneRules: [boolean | string];
  private tel1Rules: [boolean | string];
  private tel2Rules: [boolean | string];
  private luogoNascitaRules: [boolean | string];
  private dataRules: [boolean | string];
  private capRules: [boolean | string];
  private indirizzoRules: [boolean | string];

  // private model: object | null;
  private comuniStrings: string[];
  private comuni: any;
  private stati: any;
  private search: object | null;
  private searchStati: object | null;
  private isLoading: boolean;
  private isLoadingStati: boolean;
  private searchLuogoNascita: object | null;

  constructor() {
    super();
    this.e1 = 0;
    this.estero = "false";
    this.valid = true;
    this.userType = "";
    this.nomeUtente = this.info.nomeUtente;
    this.cognomeUtente = this.info.cognomeUtente;
    this.indirizzoUtente = this.info.indirizzoUtente;
    this.telefono1Utente = this.info.telefono1Utente;
    this.telefono2Utente = this.info.telefono2Utente;
    this.cod = this.info.cod;
    this.dataNascita = this.info.dataNascita;
    this.luogoNascita = this.info.luogoNascita;
    this.emailUtente = this.info.emailUtente;
    this.pecUtente = this.info.pecUtente;
    this.comuneUtente = this.info.comuneUtente;
    this.provinciaUtente = this.info.provinciaUtente;
    this.entità = this.info.entità;
    this.idCap = this.info.idCap;
    this.cap = this.info.cap;

    // this.statoNascita = this.info.idNazione
    this.statoNascita = this.info.idNazioneNascita;

    this.nomeRules = [true];
    this.cognomeRules = [true];
    this.codRules = [true];
    this.emailRules = [true];
    this.pecRules = [true];
    this.comuneRules = [true];
    this.tel1Rules = [true];
    this.tel2Rules = [true];
    this.luogoNascitaRules = [true];
    this.dataRules = [true];
    this.capRules = [true];
    this.indirizzoRules = [true];

    // this.model = null;
    this.comuniStrings = [];
    this.comuni = [];
    this.stati = [];
    this.search = null;
    this.searchStati = null;
    this.isLoading = false;
    this.isLoadingStati = false;
    this.searchLuogoNascita = null;
  }

  @Watch("nomeUtente")
  onNomeUtenteChange(value: string) {
    this.nomeUtente = value.toUpperCase();
  }

  @Watch("cognomeUtente")
  onCognomeUtenteChange(value: string) {
    this.cognomeUtente = value.toUpperCase();
  }

  @Watch("search")
  onComuneChanged(value: string) {
    if (this.comuni.length > 0) return;
    this.isLoading = true;
    data
      .dispatchComuniList(this["$store"])
      .then(response => {
        if (response !== null) {
          this.comuni = response;
        }
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore nel caricamento della lista comuni"
        );
      })
      .finally(() => (this.isLoading = false));
  }

  @Watch("searchStati")
  onStatiChanged(value: string) {
    if (this.stati.length > 0) return;
    this.isLoadingStati = true;
    data
      .dispatchStatiList(this["$store"])
      .then(response => {
        if (response !== null) {
          this.stati = response;
        }
      })
      .catch(error => {
        bus.$emit("errorOperation", "Errore nel caricamento della lista stati");
      })
      .finally(() => (this.isLoadingStati = false));
  }

  @Watch("searchLuogoNascita")
  onLuogoNascitaChanged(value: string) {
    var comuniList: string[] = [];
    if (this.comuniStrings.length > 0) return;
    this.isLoading = true;
    data
      .dispatchComuniList(this["$store"])
      .then(response => {
        if (response !== null) {
          response.forEach(element => {
            comuniList.push(element.località);
          });
          this.comuniStrings = comuniList;
        }
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore nel caricamento della lista comuni"
        );
      })
      .finally(() => (this.isLoading = false));
  }

  //metodi per la validazione degli input
  validazioneCognome() {
    var valid: boolean = false;
    if (this.cognomeUtente !== "" || this.cognomeUtente !== null) {
      valid = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.cognomeUtente);
    } else if (valid) {
      this.cognomeRules = [true];
    } else if (this.cognomeUtente === "") {
      this.cognomeRules = ["Cognome Utente necessario"];
    } else {
      this.cognomeRules = [
        "Cognome Utente deve essere compreso tra i 2 e i 50 caratteri"
      ];
    }
  }
  validazioneNome() {
    var valid: boolean = false;
    if (this.nomeUtente !== "") {
      valid = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.nomeUtente);
    }
    if (valid) {
      this.nomeRules = [true];
    } else if (this.nomeUtente === "") {
      this.nomeRules = ["Nome Utente necessario"];
    } else {
      this.nomeRules = [
        "Nome Utente deve essere compreso tra i 2 e i 50 caratteri"
      ];
    }
  }
  validazioneData() {
    var valid: boolean = false;
    if (this.dataNascita === "" || this.dataNascita === null) {
      this.dataRules = [true];
    } else {
      if (this.dataNascita !== "" || this.dataNascita !== null) {
        valid = /^[0-3]+[0-9]+\/[0-1]+[0-9]+\/[0-9]{4}$/.test(this.dataNascita);
      }
      if (valid) {
        this.dataRules = [true];
      } else {
        this.dataRules = ["La Data deve essere nel formato gg/mm/aaaa"];
      }
    }
  }
  validazioneEmail() {
    var valid: boolean = false;
    if (this.emailUtente !== "") {
      valid = /[a-zA-Z0-9._&-]+@[a-zA-Z0-9._&-]+\.[a-z]{2,}$/.test(
        this.emailUtente
      );
    }
    if (valid) {
      this.emailRules = [true];
    } else if (this.emailUtente === "") {
      this.emailRules = ["Email Utente necessaria"];
    } else {
      this.emailRules = ["Formato Email non corretto"];
    }
  }
  validazionePec() {
    var valid: boolean = false;
    if (this.pecUtente === "" || this.pecUtente === null) {
      this.pecRules = [true];
    } else {
      if (this.pecUtente !== "" && this.pecUtente !== null) {
        valid = /[a-zA-Z0-9._&-]+@[a-zA-Z0-9._&-]+\.[a-z]{2,}$/.test(
          this.pecUtente
        );
      }
      if (valid) {
        this.pecRules = [true];
      } else {
        this.pecRules = ["Formato Pec non corretto"];
      }
    }
  }
  validazioneComune() {
    var valid: boolean = false;
    if (this.comuneUtente === "") {
      this.comuneRules = [true];
    } else {
      if (this.comuneUtente !== "") {
        valid = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.comuneUtente);
      }
      if (valid) {
        this.comuneRules = [true];
      } else {
        this.comuneRules = ["Comune non può avere più di 50 caratteri"];
      }
    }
  }
  validazioneLuogoNascita() {
    var valid: boolean = false;
    if (this.luogoNascita === "" || this.luogoNascita === null) {
      this.luogoNascitaRules = [true];
    } else {
      if (this.luogoNascita !== "" || this.luogoNascita !== null) {
        valid = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.luogoNascita);
      }
      if (valid) {
        this.luogoNascitaRules = [true];
      } else {
        this.luogoNascitaRules = ["Comune non può avere più di 50 caratteri"];
      }
    }
  }
  validazioneTel() {
    var valid1: boolean = false;
    var valid2: boolean = false;
    if (this.telefono1Utente === "" || this.telefono1Utente === null) {
      this.tel1Rules = [true];
    } else {
      valid1 = /[0-9]{8,15}$/.test(this.telefono1Utente);
      if (valid1) {
        this.tel1Rules = [true];
      } else {
        this.tel1Rules = ["Il numero di telefono non ha un formato corretto"];
      }
    }
    if (this.telefono2Utente === "" || this.telefono2Utente === null) {
      this.tel2Rules = [true];
    } else {
      valid2 = /[0-9]{8,15}$/.test(this.telefono2Utente);
      if (valid2) {
        this.tel2Rules = [true];
      } else {
        this.tel2Rules = ["Il numero di telefono non ha un formato corretto"];
      }
    }
  }
  validazioneCap() {
    var valid: boolean = false;
    if (this.cap === "" || this.cap === null) {
      this.capRules = [true];
    } else {
      if (this.cap !== "" || this.cap !== null) {
        valid = /^[0-9]{5}$/.test(this.cap);
      }
      if (valid) {
        this.capRules = [true];
      } else {
        this.capRules = ["Formato Cap errato"];
      }
    }
  }
  validazioneIndirizzo() {
    var valid: boolean = false;
    if (this.indirizzoUtente === "" || this.indirizzoUtente === null) {
      this.indirizzoRules = [true];
    } else {
      if (this.indirizzoUtente !== "" || this.indirizzoUtente !== null) {
        valid = /^[a-zA-Z00-9ìèéùòà,.'\x20/-]{2,100}$/.test(
          this.indirizzoUtente
        );
      }
      if (valid) {
        this.indirizzoRules = [true];
      } else {
        this.indirizzoRules = [
          "Indirizzo non può avere più di 100 caratteri e non deve contenere caratteri speciali"
        ];
      }
    }
  }
  async executeTestInfo() {
    this.validazioneCognome();
    this.validazioneNome();
    // this.validazioneCod();
    this.validazioneLuogoNascita();
    this.validazioneData();
  }
  async executeTestRecapiti() {
    this.validazioneEmail();
    this.validazionePec();
    this.validazioneComune();
    this.validazioneTel();
    this.validazioneCap();
    this.validazioneIndirizzo();
  }

  close() {
    this.nomeRules = [true];
    this.cognomeRules = [true];
    this.codRules = [true];
    this.emailRules = [true];
    this.pecRules = [true];
    this.comuneRules = [true];
    this.tel1Rules = [true];
    this.tel2Rules = [true];
    this.luogoNascitaRules = [true];
    this.dataRules = [true];
    this.capRules = [true];
    this.indirizzoRules = [true];
    bus.$emit("closeEditDialog");
    this.e1 = 1;
  }

  next() {
    this.executeTestInfo().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        this.e1 = 2;
      }
    });
  }

  back() {
    this.e1 = 1;
    this.emailRules = [true];
    this.pecRules = [true];
    this.tel1Rules = [true];
    this.tel2Rules = [true];
    this.indirizzoRules = [true];
    this.comuneRules = [true];
    this.capRules = [true];
  }
  save() {
    this.executeTestRecapiti().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        if (this.estero == "false") {
          this.statoNascita = "086";
        }
        var payload: StudentInfo = {
          tipoSoggetto: this.info.tipoSoggetto,
          matricola: this.info.matricola,
          ruoloUtente: this.info.ruoloUtente,
          descrizioneRuolo: this.info.descrizioneRuolo,
          nomeUtente: this.nomeUtente,
          cognomeUtente: this.cognomeUtente,
          indirizzoUtente: this.indirizzoUtente,
          telefono1Utente: this.telefono1Utente,
          telefono2Utente: this.telefono2Utente,
          cod: this.info.cod,
          dataNascita: this.dataNascita,
          luogoNascita: this.luogoNascita,
          emailUtente: this.emailUtente,
          pecUtente: this.pecUtente,
          comuneUtente: this.comuneUtente,
          provinciaUtente: this.provinciaUtente,
          entità: this.entità,
          codEntità: this.info.codEntità,
          idCap: this.idCap,
          idUtente: this.info.idUtente,
          cap: this.cap,
          username: this.info.username,
          classe: this.info.classe,
          idClasse: this.info.idClasse,
          idNazioneNascita: this.statoNascita,
          diplomato: false,
          dataDiploma: "",
          urlCV: ""
        };

        user
          .dispatchEditStudentInfo(this["$store"], payload)
          .then(() => {
            bus.$emit("editedStudent");
            bus.$emit("successfullOperation", "Utente aggiornato con successo");
            this.close();
          })
          .catch(error => {
            if (error.response.status === 401) {
              bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              this["$router"].push("/login");
            } else {
              bus.$emit(
                "errorOperation",
                "Errore nella modifica delle informazioni"
              );
            }
          });
      }
    });
  }
  created() {
    var comuniList: string[] = [];
    
    if (
      this.info.idNazioneNascita !== "086" &&
      this.info.idNazioneNascita !== null
    ) {
      this.estero = "true";
    }
    data
      .dispatchComuniList(this["$store"])
      .then(result => {
        var obj = {
          id: 0,
          località: "",
          idProvincia: ""
        };
        result.forEach(element => {
          if (element.id !== 0) {
            comuniList.push(element.località);
            obj = {
              id: element.id,
              località: element.località,
              idProvincia: element.idProvincia
            };
            this.comuni.push(obj);
          }
        });
        this.comuniStrings = comuniList;
        // this.comuni = result;
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore nel caricamento della lista comuni"
        );
      });
    data
      .dispatchStatiList(this["$store"])
      .then(result => {
        var obj = {
          idStato: "",
          nomeStato: ""
        };
        result.forEach(element => {
          if (element.idStato !== "086") {
            obj = {
              idStato: element.idStato,
              nomeStato: element.nomeStato
            };
            this.stati.push(obj);
          }
        });
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore nel caricamento della lista nazioni"
        );
      });
  }
}
